<div [ngClass]="{ 'no-transition': noTransitionOnLoad }">
    <ng-content></ng-content>
</div>
